<div class="fg-view-container">
  <fg-faqs></fg-faqs>
</div>
